module.exports = __webpack_public_path__ + "media/images/item/btn_post-01aee271d770423965ae480df953239b.png";